import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { AddDoseForm, MyCircleCardItem } from '../../components'
import { Grid } from '@material-ui/core'
import { ICircle } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import { useDialog } from '../../providers/dialog-provider'
import { FirestoreContext } from '../../providers/firestore-provider'
import AddMember from '../add-member'

const MyCirclesList = () => {
  const history = useHistory()
  const { openDialog, closeDialog } = useDialog()
  const { myCircles } = useContext(FirestoreContext)

  const onGoToAddDose = (circle: ICircle) => {
    const circleId = circle.id
    const doseRef = firestore.collection(`circles/${circleId}/doses`)
    openDialog({
      color: 'primary',
      title: 'Add a dose',
      confirmText: 'ADD',
      custom: true,
      description: (
        <AddDoseForm
          doseRef={doseRef}
          onAddDose={() => closeDialog()}
          circle={circle}
          onCancelDose={() => closeDialog()}
        />
      ),
      onClose: () => true,
      // onConfirm: () => true,
      fullScreen: true,
    })
  }

  const onGoToDailyDose = (circle: ICircle) => {
    history.push(`/my-circles/${circle.id}/today-dose`, {
      ...circle,
    })
  }

  const onGoToMyCircleDetail = (circle: ICircle) => {
    history.push(`/my-circles/${circle.id}/`, {
      ...circle,
    })
  }

  const onGoToAddMember = (circle: ICircle) => {
    const circleId = circle.id
    openDialog({
      color: 'primary',
      title: 'Add member',
      confirmText: 'ADD',
      custom: true,
      description: (
        <AddMember
          selectedCircle={circle}
          circleId={circleId!}
          onAddMember={() => closeDialog()}
          onCancel={() => closeDialog()}
        />
      ),
      onClose: () => true,
      // onConfirm: () => true,
      fullScreen: true,
    })
  }

  const onGoToPastDoses = (circle: ICircle) => {
    history.push(`/my-circles/${circle.id}/past-doses`, {
      ...circle,
    })
  }

  const renderMyCirclesList = () =>
    myCircles.map((mycircle: ICircle) => {
      return (
        <Grid item xs={12} sm={4} key={mycircle.id}>
          <MyCircleCardItem
            circle={mycircle}
            onGoToAddDose={() => onGoToAddDose(mycircle)}
            onGoToAddMember={() => onGoToAddMember(mycircle)}
            onGoToDailyDose={() => onGoToDailyDose(mycircle)}
            onGoToMyCircleDetail={() => onGoToMyCircleDetail(mycircle)}
            onGoToPastDoses={() => onGoToPastDoses(mycircle)}
          />
        </Grid>
      )
    })

  if (!myCircles.length) return null

  return (
    <Grid item container spacing={3}>
      {renderMyCirclesList()}
    </Grid>
  )
}

export default MyCirclesList
